const IstitutionActionTypes = {
  GET_INSTITUTION: 'GET_INSTITUTION',
  GET_INSTITUTION_SUCCESS: 'GET_INSTITUTION_SUCCESS',
  GET_INSTITUTION_FAILED: 'GET_INSTITUTION_FAILED',
  ADD_INSTITUTION: 'ADD_INSTITUTION',
  ADD_INSTITUTION_SUCCESS: 'ADD_INSTITUTION_SUCCESS',
  ADD_INSTITUTION_ALIAS_SUCCESS: 'ADD_INSTITUTION_ALIAS_SUCCESS',
  ADD_INSTITUTION_FAILED: 'ADD_INSTITUTION_FAILED',
  DELETE_INSTITUTION: 'DELETE_INSTITUTION',
  DELETE_INSTITUTION_SUCCESS: 'DELETE_INSTITUTION_SUCCESS',
  DELETE_INSTITUTION_FAILED: 'DELETE_INSTITUTION_FAILED',
  UPDATE_INSTITUTION: 'UPDATE_INSTITUTION',
  UPDATE_INSTITUTION_SUCCESS: 'UPDATE_INSTITUTION_SUCCESS',
  UPDATE_INSTITUTION_FAILED: 'UPDATE_INSTITUTION_FAILED',
  SET_CURRENT: 'SET_CURRENT',
  CLEAR_CURRENT: 'CLEAR_CURRENT',
};
const PortalActionTypes = {
  GET_PORTAL: 'GET_PORTAL',
  GET_PORTAL_SUCCESS: 'GET_PORTAL_SUCCESS',
  GET_PORTAL_FAILED: 'GET_PORTAL_FAILED',
  ADD_PORTAL: 'ADD_PORTAL',
  ADD_PORTAL_SUCCESS: 'ADD_PORTAL_SUCCESS',
  ADD_PORTAL_FAILED: 'ADD_PORTAL_FAILED',
  DELETE_PORTAL: 'DELETE_PORTAL',
  DELETE_PORTAL_SUCCESS: 'DELETE_PORTAL_SUCCESS',
  DELETE_PORTAL_FAILED: 'DELETE_PORTAL_FAILED',
  UPDATE_PORTAL: 'UPDATE_PORTAL',
  UPDATE_PORTAL_SUCCESS: 'UPDATE_PORTAL_SUCCESS',
  UPDATE_PORTAL_FAILED: 'UPDATE_PORTAL_FAILED',
  SET_CURRENT_SETTINGS: 'SET_CURRENT_SETTINGS',
  CLEAR_CURRENT_SETTINGS: 'CLEAR_CURRENT_SETTINGS',
  SAVE_ACKNOWLEDGEMENT_SLIP: 'SAVE_ACKNOWLEDGEMENT_SLIP',
};
const ContactActionTypes = {
  SAVE_CONTACT: 'SAVE_CONTACT',
  SAVE_CONTACT_FAILED: 'SAVE_CONTACT_FAILED',
};
const OrganizationTypes = {
  CHECK_ORG_EXISTS: 'CHECK_ORG_EXISTS',
  CHECK_ORG_EXISTS_SUCCESS: 'CHECK_ORG_EXISTS_SUCCESS',
  CHECK_ORG_EXISTS_FAILED: 'CHECK_ORG_EXISTS_FAILED',
};
const OrganizationBranchesTypes = {
  SAVING_ORG_BRANCH: 'SAVING_ORG_BRANCH',
  SAVING_ORG_BRANCH_SUCCESS: 'SAVING_ORG_BRANCH_SUCCESS',
  SAVING_ORG_BRANCH_FAILED: 'SAVING_ORG_BRANCH_FAILED',

  EDITING_ORG_BRANCH: 'EDITING_ORG_BRANCH',
  EDITING_ORG_BRANCH_SUCCESS: 'EDITING_ORG_BRANCH_SUCCESS',
  EDITING_ORG_BRANCH_FAILED: 'EDITING_ORG_BRANCH_FAILED',

  DELETING_ORG_BRANCH: 'DELETING_ORG_BRANCH',
  DELETING_ORG_BRANCH_SUCCESS: 'DELETING_ORG_BRANCH_SUCCESS',
  DELETING_ORG_BRANCH_FAILED: 'DELETING_ORG_BRANCH_FAILED',

  FETCHING_ORG_BRANCHES: 'FETCHING_ORG_BRANCHES',
  FETCHING_ORG_BRANCHES_SUCCESS: 'FETCHING_ORG_BRANCHES_SUCCESS',
  FETCHING_ORG_BRANCHES_FAILED: 'FETCHING_ORG_BRANCHES_FAILED',
};
const ReminderTypes = {
  SAVING_REMINDER_SETTINGS: 'SAVING_REMINDER_SETTINGS',
  SAVING_REMINDER_SETTINGS_SUCCESS: 'SAVING_REMINDER_SETTINGS_SUCCESS',
  SAVING_REMINDER_SETTINGS_FAILED: 'SAVING_REMINDER_SETTINGS_FAILED',

  EDITING_REMINDER_SETTINGS: 'EDITING_REMINDER_SETTINGS',
  EDITING_REMINDER_SETTINGS_SUCCESS: 'EDITING_REMINDER_SETTINGS_SUCCESS',
  EDITING_REMINDER_SETTINGS_FAILED: 'EDITING_REMINDER_SETTINGS_FAILED',

  DELETING_REMINDER_SETTINGS: 'DELETING_REMINDER_SETTINGS',
  DELETING_REMINDER_SETTINGS_SUCCESS: 'DELETING_REMINDER_SETTINGS_SUCCESS',
  DELETING_REMINDER_SETTINGS_FAILED: 'DELETING_REMINDER_SETTINGS_FAILED',

  FETCHING_REMINDER_SETTINGS: 'FETCHING_REMINDER_SETTINGS',
  FETCHING_REMINDER_SETTINGS_SUCCESS: 'FETCHING_REMINDER_SETTINGS_SUCCESS',
  FETCHING_REMINDER_SETTINGS_FAILED: 'FETCHING_REMINDER_SETTINGS_FAILED',
};

const ScheduleEmailReportTypes = {
  EDITING_EMAIL_SCHEDULE_SETTINGS: 'EDITING_EMAIL_SCHEDULE_SETTINGS',
  EDITING_EMAIL_SCHEDULE_SETTINGS_SUCCESS: 'EDITING_EMAIL_SCHEDULE_SETTINGS_SUCCESS',
  EDITING_EMAIL_SCHEDULE_SETTINGS_FAILED: 'EDITING_EMAIL_SCHEDULE_SETTINGS_FAILED',

  DELETING_EMAIL_SCHEDULE_SETTINGS: 'DELETING_EMAIL_SCHEDULE_SETTINGS',
  DELETING_EMAIL_SCHEDULE_SETTINGS_SUCCESS: 'DELETING_EMAIL_SCHEDULE_SETTINGS_SUCCESS',
  DELETING_EMAIL_SCHEDULE_SETTINGS_FAILED: 'DELETING_EMAIL_SCHEDULE_SETTINGS_FAILED',

  FETCHING_EMAIL_SCHEDULE_SETTINGS: 'FETCHING_EMAIL_SCHEDULE_SETTINGS',
  FETCHING_EMAIL_SCHEDULE_SETTINGS_SUCCESS: 'FETCHING_EMAIL_SCHEDULE_SETTINGS_SUCCESS',
  FETCHING_EMAIL_SCHEDULE_SETTINGS_FAILED: 'FETCHING_EMAIL_SCHEDULE_SETTINGS_FAILED',
};

export {
  IstitutionActionTypes,
  PortalActionTypes,
  ContactActionTypes,
  OrganizationTypes,
  ReminderTypes,
  ScheduleEmailReportTypes,
  OrganizationBranchesTypes
};
